module.exports = __webpack_public_path__ + "static/img/news7.351799c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7.jpg
// module id = OVRa
// module chunks = 1